import { Button, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { createColumnHelper } from "@tanstack/react-table";
import DeleteIcon from "../../../assets/images/Icons/TrashIcon.png";
import { CustomeDialog, DeleteModal, Loader } from "../../../shared";
import { CustomTable, StoreSelectDialog } from "../../../shared/components";
import { useStoreDetails } from "../hooks";

export const StoreDetails = ({ recipeId }) => {
  const {
    state,
    assignedStoreState,
    handleModal,
    handleStoreDialogSelect,
    handleStoreToRecipe,
    onSearchHandler,
    deleteInfo,
    onDelete,
    resetDeleteInfo,
    confirmDelete,
    isLoading,
    onClearSearch,
    isStoreAssign,
    setState,
    isEditable,
  } = useStoreDetails({ recipeId });

  const { isOpenStoreDialog, selectedStores, alreadySelectedStores } =
    state.selectStoreDialogDetails;

  if (isLoading) {
    return <Loader />;
  }

  const columnHelper = createColumnHelper(assignedStoreState.assignedStoreList);
  const columns = [
    columnHelper.accessor("name", {
      header: "Store Name",
      cell: (props) => {
        const { row } = props;

        return (
          <>
            <Typography
              sx={{
                color: "#1760D2",
                textTransform: "uppercase",
              }}
            >
              {row.original.name}
            </Typography>
            {row.original.storename ? (
              <Stack direction="row" justifyContent="space-between">
                <Typography>{row.original.storename}</Typography>
              </Stack>
            ) : (
              []
            )}
          </>
        );
      },
    }),
    columnHelper.display({
      id: "actions",
      cell: (props) => {
        const { row } = props;
        return row.depth
          ? isEditable && (
              <IconButton
                size="small"
                onClick={(e) => {
                  onDelete(row.original.id);
                }}
                sx={{ p: 0 }}
              >
                <img src={DeleteIcon} alt="delete icon" style={{}} />
              </IconButton>
            )
          : "";
      },
    }),
  ];

  return (
    <>
      <CustomTable
        defaultData={assignedStoreState.assignedStoreList}
        columns={columns}
        allRowsExpanded={true}
        customRowStyle={(row) => {
          return !row.depth ? { borderBottom: "none" } : null;
        }}
        onSearchChange={onSearchHandler}
        search={assignedStoreState.search}
        manualFiltering={true}
        headerText="Assigned Store"
        subRow="subRows"
        emptyMessage="No stores added yet!."
        rightContent={
          isStoreAssign && (
            <Button
              type="button"
              color="inherit"
              variant="outlined"
              onClick={() => handleModal("store-dialog-add", true)}
              sx={{ backgroundColor: "#F5F8FC", borderColor: "#BCC7DB" }}
              startIcon={<AddIcon />}
            >
              Store
            </Button>
          )
        }
        onClearSearch={onClearSearch}
        enableTableContainerPaddingBottom
        tableHeaderStyles={{
          padding: 0,
          fontSize: "18px",
          fontWeight: 500,
          height: "52px",
        }}
      />

      <CustomeDialog
        open={isOpenStoreDialog}
        PaperProps={{
          sx: {
            width: {
              sm: "432px",
              xs: "90%",
              minHeight: "400px",
              maxHeight: "90vh",
            },
          },
        }}
        isHeader={false}
        content={
          <StoreSelectDialog
            selectedStores={selectedStores}
            alreadySelectedStores={alreadySelectedStores}
            onSelect={handleStoreDialogSelect}
            disabled={
              JSON.stringify(selectedStores) ===
              JSON.stringify(alreadySelectedStores)
            }
            isSelected={(id) => selectedStores.includes(id)}
            onSubmit={handleStoreToRecipe}
            handleClose={() => handleModal("store-dialog-add", false)}
            setState={setState}
          />
        }
      />
      <DeleteModal
        open={deleteInfo.show}
        handleClose={() => resetDeleteInfo()}
        onConfirm={() => confirmDelete()}
      />
    </>
  );
};
